import {environment} from '../../../environments/environment';
import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';

import 'rxjs/add/operator/map';
import { Activity } from '@app/shared/models/activity.model';
import {TaskInstructionType} from "@models/enums/task-instruction-type.enum";

@Injectable()
export class ActivitiesService {
    static readonly API_ACTIVITIES_BASE_PATH = `${environment.baseURL}/api/operations`;

    constructor(private http: HttpClient) {
    }

    getActivities(name: string) {
        const params = {
            name: name || ''
        };
        return this.http.get(`${ActivitiesService.API_ACTIVITIES_BASE_PATH}`, {params: params});
    }

    getActivity(id: number) {
        return this.http.get(`${ActivitiesService.API_ACTIVITIES_BASE_PATH}/${id}`);
    }

    createActivity(activity: any) {
        const adaptActivity = this.mapActivity(activity);
        return this.http.post<any>(ActivitiesService.API_ACTIVITIES_BASE_PATH, adaptActivity);
    }

    updateActivity(activity: any) {
        return this.http.put(`${ActivitiesService.API_ACTIVITIES_BASE_PATH}/${activity.id}`, this.mapActivity(activity));
    }

    updateActivities(activities: Activity[]) {
        return this.http.put(`${ActivitiesService.API_ACTIVITIES_BASE_PATH}`, activities);
    }

    deleteActivity(id: number) {
        return this.http.delete(`${ActivitiesService.API_ACTIVITIES_BASE_PATH}/${id}`);
    }

    mapActivity(activity: any) {
        return {
            name: activity.name || '',
            description: activity.description || '',
            priority: parseInt(activity.priority, 10) || 0,
            rootPath: activity.rootPath || '',
            assignedRoleId: activity.assigned.id || 0
        }
    }

    getInstructionLocationsForActivity(id: number, type: TaskInstructionType, taskId: number = null) {
        const params = new HttpParams()
                           .set('taskId', JSON.stringify(taskId))
                           .set('type', type.toString());
        return this.http.get(`${ActivitiesService.API_ACTIVITIES_BASE_PATH}/${id}/fileLocations`, {params});
    }
}
